// Colletion of actions related to sequences in the application
import * as con from "../Constants"
import { getStoredValue, setMultipleStoredValues } from "./actions"
import { processAndCleanInputSequences } from "../utils/eutaxFunctions";
import { historicResultsDB } from "./historicResultsDB";
import { largeObjectsDB } from "./largeObjectsDB";

export const resetInputSequences = () => {

    setMultipleStoredValues({
        [con.INPUT_TEXT_SEQUENCE]: null,
        [con.UPLOADED_FILE_NAME]: null,
        [con.INPUT_TEXT_SEQUENCE_STATUS]: con.STATUS_IS_MISSING,
        [con.INPUT_TEXT_SEQUENCE_MESSAGE]: null,
        [con.INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT]: {},
        [con.UPLOADED_FILE_SEQUENCE_STATUS]: con.STATUS_IS_MISSING,
        [con.UPLOADED_FILE_SEQUENCE_MESSAGE]: null,
        [con.UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT]: null
    })

    largeObjectsDB.removeValue(con.FINAL_INPUT_SEQUENCE)

}


export const resetTextInputSequence = () => {

    setMultipleStoredValues({
        [con.INPUT_TEXT_SEQUENCE]: null,
        [con.INPUT_TEXT_SEQUENCE_STATUS]: con.STATUS_IS_MISSING,
        [con.INPUT_TEXT_SEQUENCE_MESSAGE]: null,
        [con.INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT]: {},
    })

}


export const resetUploadedFileInputSequence = () => {

    setMultipleStoredValues({
        [con.UPLOADED_FILE_NAME]: null,
        [con.UPLOADED_FILE_SEQUENCE_STATUS]: con.STATUS_IS_MISSING,
        [con.UPLOADED_FILE_SEQUENCE_MESSAGE]: null,
        [con.UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT]: null
    })
}



export const pushNewAnnotationResult = async (annotationResult) => {

    await historicResultsDB.addResult(annotationResult)

}




export async function processAndSetFinalInputSequence(inputSequence, origin = con.TEXT_INPUT) {

    let maxRecords = con.DEFAULT_MAX_RECORDS;
    if (getStoredValue(con.IS_EXPERIMENTAL) === true)
        maxRecords = 15

    // Checks if the inputSequence is correct
    let [status, message, newSequence] = processAndCleanInputSequences(inputSequence, {maxRecords})

    let context = con.CONTEXT in message ? message[con.CONTEXT] : {}

    let values = [status, message[con.MESSAGE], context]
    let keys = []
    switch (origin) {
        case con.TEXT_INPUT:
            keys = [con.INPUT_TEXT_SEQUENCE_STATUS, con.INPUT_TEXT_SEQUENCE_MESSAGE, con.INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT]
            break;
        case con.FILE_INPUT:
            keys = [con.UPLOADED_FILE_SEQUENCE_STATUS, con.UPLOADED_FILE_SEQUENCE_MESSAGE, con.UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT]
            break
        default:
            message.error(`Upload type ${origin} not supported`);
            return con.STATUS_ERROR;
    }

    const statusDict = Object.fromEntries(keys.map((key, index) => [key, values[index]]));

    setMultipleStoredValues({
        ...statusDict,
    })

    await largeObjectsDB.setValue(con.FINAL_INPUT_SEQUENCE, newSequence)

    return status


}

